import { h, Component } from 'preact'
import Header from '../header'
import CsvImport from '../file-import/CsvImport'
import axios from 'axios'
import formatDateInLocalTimezone from '../utils/dateFormatting'
import { csrfToken } from '../utils/csrfToken'
import ButtonControl from '../button-control'
import ContactInviteModal from './ContactInviteModal'
import AlertComponent from '../ui-components/AlertComponent'
import tracker from '../../components/tracker/publish'

type Props = {}

type State = {
  showImportSuccess: boolean,
  showImportError: boolean,
  showContactInviteModal: boolean,
  isLoading: boolean,
  uploadedCount?: number,
  errors?: [],
  importId?: string,
  alertMessageType?: string,
  alertMessage?: string
}

class ContactImport extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.setState({
      showImportSuccess: false,
      showImportError: false,
      showContactInviteModal: false,
      isLoading: false
    })

    this.onImportContacts = this.onImportContacts.bind(this)
    this.onContactsInvited = this.onContactsInvited.bind(this)
  }

  async onImportContacts (file: File) {
    this.setState({ isLoading: true })
    const defaultUserTag = `CSV import - ${formatDateInLocalTimezone(Date.now() / 1000).replace(',', '')}`

    let formData = new window.FormData()
    formData.append('contacts', file)
    formData.append('userTags', JSON.stringify([defaultUserTag]))
    formData.append('yip_csrf_token', csrfToken())

    await axios
      .post('/contact/upload', formData)
      .then(res => {
        this.setState({
          showImportSuccess: true,
          isLoading: false,
          uploadedCount: res.data.importedContacts,
          errors: res.data.errors,
          importId: res.data.importId
        })
      })
      .catch(() => this.setState({
        showImportError: true,
        isLoading: false
      }))
  }

  onContactsInvited (success: boolean, isGroupInvite: boolean = false) {
    this.setState({
      alertMessageType: success ? 'success' : 'error',
      alertMessage: success ? 'Invitations have been sent successfully!' : 'Something went wrong, please try again.',
      showContactInviteModal: false
    })

    if (!success) return

    tracker.trackEvent('userevent', {
      type: 'Contact Invited',
      total_contacts_invited: this.state.uploadedCount,
      invite_type: isGroupInvite ? 'join user group' : 'join community'
    })
  }

  render (_:Props, { showImportSuccess, showImportError, showContactInviteModal, isLoading, uploadedCount, errors, alertMessage, alertMessageType, importId }:State) {
    return (
      <div className='contact-import'>
        <Header
          title='Import Contact'
          disableSaveButton
          disableCancelButton
          hasBreadcrumb
          breadcrumbText='Contact Overview'
          breadcrumbLink='/contact/overview'
        />
        {alertMessageType && <AlertComponent
          messageType={alertMessageType}
          message={alertMessage}
          sticky
          isVisibleFor={5000}
          onTimeoutEnd={() => this.setState({ alertMessageType: undefined, alertMessage: '' })}
          onClose={() => this.setState({ alertMessageType: undefined, alertMessage: '' })}
        />}
        <CsvImport
          infoText='Please upload a CSV file containing email address and name.'
          calloutText='Importing contacts via csv allows you to add multiple contacts at once. If an email address in your CSV matches an existing email address of a user or contact, they will not be added.'
          uploadFile={this.onImportContacts}
          showImportSuccess={showImportSuccess}
          showImportError={showImportError}
          onTryAgain={() => this.setState({ showImportError: false })}
          isLoading={isLoading}
          uploadedCount={uploadedCount}
          errors={errors}
          type='contact'
          successAction={
            <ButtonControl
              title={`Send invite to all ${uploadedCount} imported contacts`}
              newStyle
              onClick={() => this.setState({ showContactInviteModal: true })}
              size='medium'
              variant='brand'
            />
          }
        />
        {importId && <ContactInviteModal
          importId={importId}
          isOpen={showContactInviteModal}
          contactCount={uploadedCount || 0}
          onClose={() => this.setState({ showContactInviteModal: false })}
          onContactsInvited={this.onContactsInvited}
        />}
      </div>
    )
  }
}

export default ContactImport
